import { Box, Flex, Text } from '@chakra-ui/react';
import DownloadButtons from '@/travo/components/ui/buttons/DownloadButtons';
import { Container, DisplayHeading, Eyebrow, Postmark } from '@/travo/components/ui/postmark';
import { useCopy } from '@/travo/i18n';

/** Airmail envelope with the download badges. */
const FinalCTA = () => {
  const copy = useCopy();

  return (
    <Container as="section" id="download" pb={{ base: '80px', md: '112px' }}>
      <Box className="airmail" p="14px">
        <Flex
          direction="column"
          align="center"
          textAlign="center"
          gap="22px"
          position="relative"
          bg="card"
          px="24px"
          py={{ base: '48px', md: '80px' }}
        >
          <Postmark
            ring="TRAVOLABS.COM · FREE · iOS · ANDROID"
            big="Go!"
            position="absolute"
            right="4%"
            top="24px"
            w="130px"
            h="130px"
            color="stamp"
            opacity={0.8}
            transform="rotate(10deg)"
            display={{ base: 'none', md: 'block' }}
          />
          <Eyebrow>{copy.cta.eyebrow}</Eyebrow>
          <DisplayHeading fontSize={{ base: '38px', md: '64px' }} maxW="12em">
            {copy.cta.title}
          </DisplayHeading>
          <Text maxW="32em" color="inkSoft">
            {copy.cta.body}
          </Text>
          <DownloadButtons size={54} />
        </Flex>
      </Box>
    </Container>
  );
};

export default FinalCTA;
